export default "__VITE_ASSET__Dfo8p5TI__"